var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2738 20.8579H28.6067C21.8969 20.8579 17.373 27.834 20.0162 34.1052C20.3843 34.9787 21.2291 35.5451 22.1638 35.5451H23.8073C24.3613 35.5451 24.8442 35.9285 24.9786 36.475L27.0944 45.0809C27.5356 46.8754 29.1212 48.1342 30.9402 48.1342C32.7593 48.1342 34.3449 46.8754 34.7861 45.0809L36.9019 36.475C37.0363 35.9285 37.5192 35.5451 38.0731 35.5451H39.7167C40.6514 35.5451 41.4961 34.9787 41.8643 34.1052C44.5075 27.834 39.9836 20.8579 33.2738 20.8579Z",
    fill: "#8F79D7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.9403,
    cy: 15.013,
    rx: 5.84492,
    ry: 5.84492,
    fill: "#8F79D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2722 19.0257L7.04935 11.3915",
    stroke: "#161119",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7543 20.7723C13.7543 20.7723 19.6434 20.1147 20.2721 19.0258C20.9008 17.9369 18.5257 12.5081 18.5257 12.5081",
    stroke: "#161119",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7278 19.0257L54.9507 11.3915",
    stroke: "#161119",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2457 20.7723C48.2457 20.7723 42.3566 20.1147 41.7279 19.0258C41.0992 17.9369 43.4743 12.5081 43.4743 12.5081",
    stroke: "#161119",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6084 40.974L6.38559 48.6082",
    stroke: "#161119",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8622 47.4919C17.8622 47.4919 20.2372 42.063 19.6085 40.9741C18.9799 39.8852 13.0908 39.2277 13.0908 39.2277",
    stroke: "#161119",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3916 40.974L55.6144 48.6082",
    stroke: "#161119",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1378 47.4919C44.1378 47.4919 41.7628 42.063 42.3915 40.9741C43.0201 39.8852 48.9092 39.2277 48.9092 39.2277",
    stroke: "#161119",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIn);
export default __webpack_public_path__ + "static/media/icon-in.6cbbf447d0882fd7740220fb0a361fe8.svg";
export { ForwardRef as ReactComponent };